<template>
	<div class="close-valve-cmd-records">
		<h3 class="diagnosis-title">下发关阀指令记录</h3>
		<el-radio-group v-model="systemId" size="small" style="margin-top: 12px" @change="handleSystemIdChange">
			<el-radio-button label="0">GCCP</el-radio-button>
			<el-radio-button v-if="detail.bizSysType == 1" label="1">金卡云</el-radio-button>
			<el-radio-button v-if="detail.bizSysType == 2" label="2">ENESYS</el-radio-button>
		</el-radio-group>
		<div class="content" v-loading="loading">
			<gc-table border :columns="columns" :table-data="tableData" :showPage="false"></gc-table>
		</div>
	</div>
</template>

<script>
import { isBlank } from '@/utils/validate'
import { apiTraceCloseValveCmdList } from '@/apis/diagnosis.api'

export default {
	props: {
		detail: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			tableData: [],
			columns: [
				{
					key: 'createTime',
					name: '时间',
				},
				{
					key: 'cmdName',
					name: '指令名称',
					tooltip: true,
				},
				{
					key: 'status',
					name: '指令状态',
					render: (h, row) => {
						let statusMap = {
							0: { class: 'dot-warning', text: '待执行' },
							1: { class: 'dot-success', text: '成功' },
							2: { class: 'dot-error', text: '失败' },
						}
						let val = row.status
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{
					key: 'detail',
					name: '下发指令数据',
					tooltip: true,
				},
				{
					key: 'cmdUserInfo',
					name: '操作人',
					tooltip: true,
				},
			],
			systemId: '0',
			loading: false,
		}
	},

	methods: {
		async queryTraceCloseValveCmdList(iotDeviceId) {
			this.loading = true
			try {
				const data = await apiTraceCloseValveCmdList(iotDeviceId, this.systemId)
				this.tableData = data
			} finally {
				this.loading = false
			}
		},

		handleSystemIdChange() {
			this.queryTraceCloseValveCmdList(this.detail.iotDeviceId)
		},
	},

	watch: {
		detail: {
			handler(newVal) {
				if (newVal && newVal.iotDeviceId) {
					this.queryTraceCloseValveCmdList(newVal.iotDeviceId)
				}
			},
			deep: true,
		},
	},
}
</script>
<style lang="scss" scoped>
.content {
	margin-top: 16px;
}
</style>
